import { AdminUpdateChatMessageInput, ChatMessageItem } from '../../graphql/API';
import { venueUpdateChatMessage } from '../../graphql/mutations';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueUpdateChatMessageApi = async (
  input: AdminUpdateChatMessageInput,
): Promise<ChatMessageItem> => {
  const result = await executeGql(venueUpdateChatMessage, { input });
  return processGqlResult<ChatMessageItem>('venueUpdateChatMessage', result);
};
